// extracted by mini-css-extract-plugin
export default {"objectActionModal":"FolderActions_objectActionModal__pOVHl","objectActionListItem":"FolderActions_objectActionListItem__itX7s"};